module.exports = __webpack_public_path__ + "img/12.1b40f31c.jpg";